import { BarChartProps } from '@mui/x-charts-pro';
import IncBarChart from 'components/charts/inc-bar-chart/inc-bar-chart.component';
import { useTranslation } from 'react-i18next';
import { useHideAllLocationSections } from './active-customers.hooks';

export type ActiveCustomersAcquisitionSourceProps = {
  series: BarChartProps['series'];
  xlabels: string[];
  loading?: boolean;
};

/**
 * Acquisition Source (All Members) bar chart. Reach-based, so it renders only
 * alongside the New Members / Conversion Rate cards — hidden for a
 * location-scoped admin or when the report is filtered to specific stores.
 */
const ActiveCustomersAcquisitionSource = ({
  series,
  xlabels,
  loading = false,
}: ActiveCustomersAcquisitionSourceProps) => {
  const { t } = useTranslation();

  if (useHideAllLocationSections()) return null;

  return (
    <IncBarChart
      data-testid="ActiveCustomers.FirstSourceChart"
      title={t('page.guestJourney.activeCustomers.firstSourceChart.title')}
      series={series}
      xlabels={xlabels}
      BarChartProps={{ loading }}
    />
  );
};

export default ActiveCustomersAcquisitionSource;
